exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".apply .wrapper .application .app-display .left-side .info .inputs input[type=email]{max-width:480px;width:100%;border:2px solid #cfcfd2;border-radius:2px;font-family:Open Sans,sans-serif;font-size:14px;padding:7px 8px;background:#fff;margin-top:7px;margin-bottom:5px;color:#545454;box-shadow:none}.apply .wrapper .application .app-display .left-side .info .inputs input[type=email]:focus{box-shadow:0 0 2px 1px #3ec19d;border-color:#3ec19d}@media screen and (max-width:768px){.apply .wrapper .application .app-display .left-side .info .inputs input[type=email]{max-width:100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./directives/freeforms/email/email.css
// module id = 382
// module chunks = 0